export const styles = {
  modal: {
    minHeight: "568px",
    width: "803px !important",
    padding: "20px",
    borderRadius: "16px",
    backgroundColor: "#fff",
    maxHeight: "90vh",
    margin: "0",

    scrollbarWidth: "none",
    msOverflowStyle: "none",

    "&::-webkit-scrollbar": {
      width: "0px",
      height: "0px",
    },
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  modalTitle: {
    fontSize: "28px",
    fontWeight: 600,
    lineHeight: "36px",
    color: "#000",
  },
  closeIcon: {
    width: 24,
    height: 24,
    color: "#9DA6B0",
    backgroundColor: "#52575DB2",
  },
  selectedBox: {
    marginTop: "32px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  selectedLabel: {
    fontSize: "15px",
    fontWeight: 600,
  },
  selectedBlock: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    marginTop: "16px",
  },
  searchWrapper: {
    marginTop: "32px",
    marginBottom: "20px",
    width: "100%",
    backgroundColor: "#FBFBFB",
    border: "1px solid #F4F5F6",
    borderRadius: "12px",
    padding: "14px 8px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  marketListWrapper: {
    minHeight: "280px",
  },
  marketList: {
    display: "flex",
    minHeight: "54px",
    flexWrap: "wrap",
    maxHeight: "280px",
    overflowY: "auto",

    "&::-webkit-scrollbar": {
      width: "4px",
    },

    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#C6CACE",
      borderRadius: "2px",
      height: "80px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
  },
  allMarketsToggle: {
    top: "20px",
    right: "20px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  toggleText: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#000",
  },
  searchIcon: {
    width: 24,
    height: 24,
    color: "#9DA6B0",
  },

  searchInput: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0%",
    color: "#2A2D31",
    caretColor: "#5b87f8",

    "&::placeholder": {
      color: "#9DA6B0",
    },
  },
  searchResultsRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    marginBottom: "10px",
  },

  searchResults: {
    color: "#000",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "28px",
  },

  searchResultsCount: {
    color: "#000",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "28px",
  },
  noResults: {
    display: "flex",
    height: "232px",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center",
    alignSelf: "stretch",
    color: "#9DA6B0",
    textAlign: "center",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "155%",
  },
};
